import { GET_TIRE_MODEL_BEGIN, GET_TIRE_MODEL_SUCCESS } from "./type";

const initialState = {
    items: [],
    loading: false
}
export const TireModelReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TIRE_MODEL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case GET_TIRE_MODEL_SUCCESS:
            return action.payload
        default:
            return state
    }
};
